import React, { useEffect, useMemo, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import CenterButton from "components/Organisms/map/CenterButton"
import Map from "components/Organisms/map/Map"
import AllDCLocations from "components/Templates/AllDCLocations"
import useAuth from "hooks/useAuth"
import useTripsSnapshot from "hooks/useTripsSnapshot"
import {
  VEHICLE_CHANGE_MAP_CENTER,
  VEHICLE_CHANGE_MAP_ZOOM,
} from "store/vehicle.redux"
import { useAssignedTripsMap } from "../assigned/useAssignedTrips"
import MapMarkers from "./MapMarkers"
export default function ViewTripsMap() {
  const auth = useAuth()
  const { trips } = useAssignedTripsMap()
  const { data } = useTripsSnapshot()

  // Get only the trips which are in assignedTripsFor date query(fleet database)
  // and then add the location from the firebase realtime database to create
  // a single source of truth
  const availableTrips = useMemo(() => {
    return trips
      ?.filter(trip => data?.[trip?.uuid])
      ?.map(trip => ({
        ...trip,
        latitude: parseFloat(data?.[trip?.uuid].latitude),
        longitude: parseFloat(data?.[trip?.uuid].longitude),
      }))
  }, [data, trips])

  const googleMapRef = useRef(null)
  const zoom = useSelector(state => (state as any).vehicle.map.zoom)
  const center = useSelector(state => (state as any).vehicle.map.center)
  const dispatch = useDispatch()
  useEffect(() => {
    // This function executes whenever the component is unmounted
    // Basically we want to save the center & zoom of the map whenever the user
    // changes routes, that way he lands on the same view whenever he comes back
    return function cleanup() {
      // Set Map Center
      const newCenter = googleMapRef.current?.getCenter?.()?.toJSON()
      if (newCenter) {
        dispatch({
          type: VEHICLE_CHANGE_MAP_CENTER,
          payload: newCenter,
        })
      }
      const zoom = googleMapRef.current?.getZoom?.()
      if (zoom || zoom === 0) {
        dispatch({
          type: VEHICLE_CHANGE_MAP_ZOOM,
          payload: zoom,
        })
      }
    }
  }, [dispatch])

  // if (!isLoaded) return <Spinner />;

  return (
    <div
      style={{
        height: "calc(100vh - 128px)",
        width: "100%",
      }}
      className="vt-map"
    >
      <Map
        mapTypeId="satellite"
        mapContainerStyle={{
          height: "100%",
          width: "100%",
        }}
        onLoad={googleMap => {
          googleMapRef.current = googleMap
        }}
        center={center}
        zoom={zoom}
        height={"60vh"}
        width="100%"
      >
        <CenterButton
          onClick={e => {
            if (googleMapRef.current && availableTrips?.length !== 0) {
              const tripBounds = new window.google.maps.LatLngBounds()
              availableTrips.forEach(t => {
                if (t?.latitude && t?.longitude) {
                  tripBounds.extend({
                    lat: t?.latitude,
                    lng: t?.longitude,
                  })
                }
              })
              googleMapRef.current.fitBounds(tripBounds)
            }
          }}
        />
        <MapMarkers availableTrips={availableTrips} />
        <AllDCLocations variables={{ pocId: auth.user.id }} />
      </Map>
    </div>
  )
}
